import { UISelectorType } from "../../../utilities/types";
import { ChatCategory, ChatCustomizationEntry, ChatSubCategory } from "./types";

export const chatCustomizeEntries: ChatCustomizationEntry[] = [
    // Appearance
    {
        id: 'themes',
        displayName: 'Theme',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.ThemePreset,
        uiSelectorType: UISelectorType.themeSelector,
        containerName: "UI",
    },
    {
        id: 'accent',
        displayName: 'Accent color',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'backgroundColor',
        displayName: 'Background color',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'backgroundImage',
        displayName: 'Background image',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'subtle',
        displayName: 'Secondary text color',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptLinkColor',
        displayName: 'Link color',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'backgroundPosition',
        displayName: 'Background image position',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.BackgroundImage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'backgroundRepeat',
        displayName: 'Background image repetition',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.BackgroundImage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'backgroundSize',
        displayName: 'Background image size',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.BackgroundImage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'primaryFont',
        displayName: 'Primary font',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'rootFontSize',
        displayName: 'Base font size',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'transcriptFontSize',
        displayName: 'Transcript font size',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'fontSizeSmall',
        displayName: 'Small text size',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },
    {
        id: 'lineHeight',
        displayName: 'Line height',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'messageActivityWordBreak',
        displayName: 'Word wrapping rule',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.Typography,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'paddingRegular',
        displayName: 'Message padding',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.SpacingAndShape,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'restylingsEnabled',
        displayName: 'Enable layout v1',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.LayoutVersion,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'druidNewLayoutEnabled',
        displayName: 'Enable layout v2',
        category: ChatCategory.Appearance,
        subCategory: ChatSubCategory.LayoutVersion,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },

    // Window
    {
        id: 'height',
        displayName: 'Chat window height',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'width',
        displayName: 'Chat window width',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'minWidth',
        displayName: 'Minimum chat window width',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'chatBoxBorderRadius',
        displayName: 'Top corner radius',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Frame,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'chatBoxBottomRadius',
        displayName: 'Bottom corner radius',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Frame,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'chatBoxBorderColor',
        displayName: 'Border color',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Frame,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'chatBoxBorderSize',
        displayName: 'Border thickness',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Frame,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'shellPaddingLeftRight',
        displayName: 'Shell padding left and right',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Spacing,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'shellPaddingTopBottom',
        displayName: 'Shell padding top and bottom',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Spacing,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'resizableEnabled',
        displayName: 'Allow manual resize',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Behavior,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'autoScrollSnapOnPage',
        displayName: 'Open transcript at first message',
        category: ChatCategory.Window,
        subCategory: ChatSubCategory.Behavior,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },

    // Header
    {
        id: 'chatTitle',
        displayName: 'Chat title',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Content,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'chatDescription',
        displayName: 'Chat description',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Content,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'showAvatar',
        displayName: 'Show avatar',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'showCloseButton',
        displayName: 'Show close button',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'showLanguageSelector',
        displayName: 'Show language selector',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'showChangeSideButton',
        displayName: 'Show switch-side button',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'showReload',
        displayName: 'Show reload button',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'showReset',
        displayName: 'Show reset button',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'headerCustomIconEnabled',
        displayName: 'Show custom header icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'headerFontSize',
        displayName: 'Header font size',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerBackground',
        displayName: 'Background color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerTextColor',
        displayName: 'Text color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerTextColorOnHover',
        displayName: 'Hover text color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerTopBorderRadius',
        displayName: 'Top corner radius',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        hidden: ['!UI.druidNewLayoutEnabled'],
    },
    {
        id: 'headerBottomBorderRadius',
        displayName: 'Bottom corner radius',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        hidden: ['!UI.druidNewLayoutEnabled'],
    },
    {
        id: 'headerOuterPadding',
        displayName: 'Outer padding',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
        hidden: true,
    },
    {
        id: 'headerBorderColor',
        displayName: 'Border color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerBorderSizeBottom',
        displayName: 'Bottom border thickness',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerDescriptionTextColor',
        displayName: 'Description text color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerInnerPaddingLeftRight',
        displayName: 'Inner padding left and right',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'headerInnerPaddingTopBottom',
        displayName: 'Inner padding top and bottom',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'headerBorderSizeLeft',
        displayName: 'Left border thickness',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerOuterPaddingLeftRight',
        displayName: 'Outer padding left and right',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'headerOuterPaddingTopBottom',
        displayName: 'Outer padding top and bottom',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'headerBorderSizeRight',
        displayName: 'Right border thickness',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerBorderSizeTop',
        displayName: 'Top border thickness',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Styling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
        hidden: ['UI.restylingsEnabled'],
    },
    {
        id: 'headerAvatarBorderRadius',
        displayName: 'Header avatar corner radius (%)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Avatar,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "UI",
        hidden: ['UI.headerOptions.showAvatar'],
    },
    {
        id: 'headerButtonColorOnFocus',
        displayName: 'Button icon / text color (focus)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonBackgroundColor',
        displayName: 'Background color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonBackgroundColorOnFocus',
        displayName: 'Background color (focus)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonBackgroundColorOnHover',
        displayName: 'Background color (hover)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonBorder',
        displayName: 'Button border (CSS)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonColor',
        displayName: 'Button icon / text color',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonColorOnDisabled',
        displayName: 'Button icon / text color (disabled)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonColorOnHover',
        displayName: 'Button icon / text color (hover)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonTransform',
        displayName: 'Button transform (CSS)',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonDisabledOpacity',
        displayName: 'Disabled opacity',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerActionsGap',
        displayName: 'Gap between header actions',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerLanguageSelectorScale',
        displayName: 'Language selector scale',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'headerButtonPadding',
        displayName: 'Padding',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Buttons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'v2_contextMenu_icon',
        displayName: 'Context menu icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_minimize_icon',
        displayName: 'Minimize icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_changeSide_icon',
        displayName: 'Change side icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_header_custom_icon',
        displayName: 'Header custom icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_login_icon',
        displayName: 'Login icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_logout_icon',
        displayName: 'Logout icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_optionsMenu_icon',
        displayName: 'Options menu icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_reload_icon',
        displayName: 'Reload icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_reset_icon',
        displayName: 'Reset icon',
        category: ChatCategory.Header,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },

    // Avatars
    {
        id: 'botAvatarImage',
        displayName: 'Agent avatar image',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.AgentAvatar,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'botAvatarBackgroundColor',
        displayName: 'Agent avatar background',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.AgentAvatar,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'userAvatarImage',
        displayName: 'User avatar image',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.UserAvatar,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
        hidden: ['!disableUserAvatarChatBubble'],
    },
    {
        id: 'userAvatarBackgroundColor',
        displayName: 'User avatar background',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.UserAvatar,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'avatarSize',
        displayName: 'Avatar size',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.SizeAndShape,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'avatarBorderRadius',
        displayName: 'Avatar corner radius',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.SizeAndShape,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },
    {
        id: 'disableBotAvatarChatBubble',
        displayName: 'Hide agent avatar beside messages',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.VisibilityInMessages,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'disableUserAvatarChatBubble',
        displayName: 'Hide user avatar beside messages',
        category: ChatCategory.Avatars,
        subCategory: ChatSubCategory.VisibilityInMessages,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },

    // Conversation
    {
        id: 'bubbleMinHeight',
        displayName: 'Minimum height',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleAttachmentMaxWidth',
        displayName: 'Maximum attachment width',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleImageMaxHeight',
        displayName: 'Maximum image height',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleMessageMaxWidth',
        displayName: 'Maximum message width (%)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleAttachmentMinWidth',
        displayName: 'Minimum attachment width',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleImageMinHeight',
        displayName: 'Minimum image height',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleMessageMinWidth',
        displayName: 'Minimum message width (%)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.BubbleLayout,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleBackground',
        displayName: 'Background',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleTextColor',
        displayName: 'Text color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleBorderColor',
        displayName: 'Border color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleBorderStyle',
        displayName: 'Border style',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleBorderWidth',
        displayName: 'Border width',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleNubSize',
        displayName: 'Bubble tail size',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleNubOffset',
        displayName: 'Bubble tail position',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubblePaddingLeftRight',
        displayName: 'Padding left and right',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubblePaddingTopBottom',
        displayName: 'Padding top and bottom',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.AgentBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserBackground',
        displayName: 'Background',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserTextColor',
        displayName: 'Text color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserBorderColor',
        displayName: 'Border color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserBorderStyle',
        displayName: 'Border style',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserBorderWidth',
        displayName: 'Border width',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserNubSize',
        displayName: 'Bubble tail size',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserNubOffset',
        displayName: 'Bubble tail position',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserPaddingLeftRight',
        displayName: 'Padding left and right',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'bubbleFromUserPaddingTopBottom',
        displayName: 'Padding top and bottom',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.UserBubble,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptMaxWidth',
        displayName: 'Maximum transcript width',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptLayout,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'transcriptRowMarginInline',
        displayName: 'Transcript row margin, left and right',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'groupTimestamp',
        displayName: 'Show timestamps',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.Timestamps,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'timestampColor',
        displayName: 'Timestamp color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.Timestamps,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'timestampFormat',
        displayName: 'Timestamp format',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.Timestamps,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'customTimestampFormat',
        displayName: 'Custom timestamp pattern',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.Timestamps,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'activityStatusReadColor',
        displayName: 'Delivery status color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'activityStatusBotName',
        displayName: 'Agent display name',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'activityStatusShowBotName',
        displayName: 'Show agent name',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'activityStatusUserName',
        displayName: 'User display name',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'activityStatusShowUserName',
        displayName: 'Show user name',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'botActivitiesActionsEnabled',
        displayName: 'Show message actions',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.MessageStatus,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'disableTypingAnimation',
        displayName: 'Hide typing animation',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TypingIndicator,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'showTypingName',
        displayName: 'Show typing agent name',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TypingIndicator,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'disableTyping',
        displayName: 'Disable typing (behavior to verify)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TypingIndicator,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'transcriptOverlayButtonColor',
        displayName: 'Button text color',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptOverlayButtonBackground',
        displayName: 'Button background',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptOverlayButtonColorOnFocus',
        displayName: 'Button text color (focus)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptOverlayButtonBackgroundOnFocus',
        displayName: 'Button background (focus)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptOverlayButtonColorOnHover',
        displayName: 'Button text color (hover)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'transcriptOverlayButtonBackgroundOnHover',
        displayName: 'Button background (hover)',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.rgbaSelector,
        containerName: "styleOptions",
    },
    {
        id: 'scrollToEndButtonBehavior',
        displayName: 'Scroll-to-end button',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'scrollToEndButtonFontSize',
        displayName: 'Scroll-to-end font size',
        category: ChatCategory.Conversation,
        subCategory: ChatSubCategory.TranscriptControls,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },

    // Agent messages
    {
        id: 'greetingMessageColor',
        displayName: 'Text color or gradient',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageBackground',
        displayName: 'Background',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessagePadding',
        displayName: 'Padding',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageMargin',
        displayName: 'Margin',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageFontSize',
        displayName: 'Font size',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageFontWeight',
        displayName: 'Font weight',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageAnimation',
        displayName: 'Entrance animation',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "UI",
    },
    {
        id: 'greetingMessageIcon',
        displayName: 'Greeting icon (SVG)',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'alignSendboxInCenter',
        displayName: 'Center composer with greeting in full-screen mode',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'hideWelcomeMessageAfterUserInput',
        displayName: 'Hide greeting after the first user input',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.GreetingMessage,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageColor',
        displayName: 'Text color or gradient',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageBackground',
        displayName: 'Background',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessagePadding',
        displayName: 'Padding',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageMargin',
        displayName: 'Margin',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageFontSize',
        displayName: 'Font size',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageFontWeight',
        displayName: 'Font weight',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'informativeMessageIcon',
        displayName: 'Icon (SVG)',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.InformativeMessage,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'reasoningCardAccentColor',
        displayName: 'Accent color',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'reasoningCardBackgroundColor',
        displayName: 'Background color',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'reasoningCardBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'reasoningCardBorderColor',
        displayName: 'Border color',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'reasoningCardTextColor',
        displayName: 'Primary text color',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'reasoningCardSecondaryTextColor',
        displayName: 'Secondary text color',
        category: ChatCategory.AgentMessages,
        subCategory: ChatSubCategory.ReasoningCard,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },

    // Rich content & actions
    {
        id: 'enableHeroCardAvatar',
        displayName: 'Show avatar',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardBorderColor',
        displayName: 'Border color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardBorderSize',
        displayName: 'Border thickness',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardInnerPadding',
        displayName: 'Inner padding',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardTitleTextSize',
        displayName: 'Title size',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardTitleTextColor',
        displayName: 'Title color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardDescriptionTextColor',
        displayName: 'Description color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'richCardWrapTitle',
        displayName: 'Wrap long card titles',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCards,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'heroCardButtonsColor',
        displayName: 'Background',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsColorOnHover',
        displayName: 'Background (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsColorOnFocus',
        displayName: 'Background (focus)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsTextColor',
        displayName: 'Text color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsTextColorOnHover',
        displayName: 'Text color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsTextColorOnFocus',
        displayName: 'Text color (focus)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsBorderColor',
        displayName: 'Border color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'heroCardButtonsBorderSize',
        displayName: 'Border thickness',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.HeroCardButtons,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsPadding',
        displayName: 'Padding',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsBackgroundColor',
        displayName: 'Background',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsBackgroundColorOnHover',
        displayName: 'Background (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsTextColor',
        displayName: 'Text color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsTextColorOnHover',
        displayName: 'Text color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsBorderColor',
        displayName: 'Border color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'buttonsBorderColorOnHover',
        displayName: 'Border color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.InConversationButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'suggestedActionTextColor',
        displayName: 'Text color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBorderColor',
        displayName: 'Border color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBorderStyle',
        displayName: 'Border style',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBorderWidth',
        displayName: 'Border width',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBackgroundColor',
        displayName: 'Background color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionBackgroundColorOnHover',
        displayName: 'Background color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtons,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionDisabledBackground',
        displayName: 'Background',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonsDisabled,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionDisabledTextColor',
        displayName: 'Text color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonsDisabled,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionDisabledBorderColor',
        displayName: 'Border color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonsDisabled,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionDisabledBorderStyle',
        displayName: 'Border style',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonsDisabled,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionDisabledBorderWidth',
        displayName: 'Border width',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonsDisabled,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionLayout',
        displayName: 'Arrangement',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonLayout,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionHeight',
        displayName: 'Button height',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionsCarouselFlipperBoxWidth',
        displayName: 'Carousel container width',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionsCarouselFlipperSize',
        displayName: 'Carousel flipper size',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'suggestedActionsStackedHeight',
        displayName: 'Stacked container height',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.ChoiceButtonLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'dropdownMenuBackgroundColor',
        displayName: 'Background color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuBoxShadow',
        displayName: 'Box shadow',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownRootPaddingInline',
        displayName: 'Dropdown padding, left and right',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuBorder',
        displayName: 'Menu border (CSS)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuMarginBottom',
        displayName: 'Menu bottom offset',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuMarginTop',
        displayName: 'Menu top offset',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownMenuPadding',
        displayName: 'Padding',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownShell,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemBackgroundColor',
        displayName: 'Background color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemBackgroundColorOnActive',
        displayName: 'Background color (active)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemBackgroundColorOnHover',
        displayName: 'Background color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemBorderRadius',
        displayName: 'Border radius',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemFontSize',
        displayName: 'Font size',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemGap',
        displayName: 'Gap between item icon and text',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemHeight',
        displayName: 'Height',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemPadding',
        displayName: 'Item inner padding',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemColor',
        displayName: 'Text color',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemColorOnActive',
        displayName: 'Text color (active)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropdownItemColorOnHover',
        displayName: 'Text color (hover)',
        category: ChatCategory.RichContentAndActions,
        subCategory: ChatSubCategory.DropdownItems,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },

    // Composer
    {
        id: 'hideDruidSendBox',
        displayName: 'Hide the composer',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Availability,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'disableFileUpload',
        displayName: 'Disable file upload',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Availability,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'inputBetweenActionButtons',
        displayName: 'Place input between action buttons',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Availability,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'emojiPickerEnabled',
        displayName: 'Show emoji picker',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Availability,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxFontSize',
        displayName: 'Composer font size',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxHeight',
        displayName: 'Composer height',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxMaxHeight',
        displayName: 'Maximum height',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'druidSendBoxPaddingLeftRight',
        displayName: 'Outer padding, left and right',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxPaddingTop',
        displayName: 'Outer padding, top',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxPaddingBottom',
        displayName: 'Outer padding, bottom',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxTextBoxPadding',
        displayName: 'Input padding',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxInnerPaddingLeftRight',
        displayName: 'Input padding, left and right',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxInnerPaddingTopBottom',
        displayName: 'Input padding, top and bottom',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxTextWrap',
        displayName: 'Wrap typed text',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxIconSize',
        displayName: 'Composer button icon size',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'druidSendBoxButtonsGap',
        displayName: 'Gap between composer buttons',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxMaxWidth',
        displayName: 'Maximum composer width',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Layout,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxTextColor',
        displayName: 'Typed text color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxBackground',
        displayName: 'Background',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxPlaceholderColor',
        displayName: 'Placeholder color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxDisabledTextColor',
        displayName: 'Disabled text color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxBorderBottom',
        displayName: 'Bottom border (CSS)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Borders,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'druidSendBoxInnerBorderRadius',
        displayName: 'Inner border radius',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Borders,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxBorderLeft',
        displayName: 'Left border (CSS)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Borders,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxBorderRight',
        displayName: 'Right border (CSS)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Borders,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxBorderTop',
        displayName: 'Top border (CSS)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Borders,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonColor',
        displayName: 'Button color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonColorOnHover',
        displayName: 'Button color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonColorOnFocus',
        displayName: 'Button color (focus)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonColorOnDisabled',
        displayName: 'Button color (disabled)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'druidSendBoxButtonBackgroundColorOnFocus',
        displayName: 'Composer button background color (focus)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'druidSendBoxButtonBackgroundColorOnHover',
        displayName: 'Composer button background color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonMessageSendColor',
        displayName: 'Send button color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonMessageSendColorOnDisabled',
        displayName: 'Send button color (disabled)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonMessageSendColorOnFocus',
        displayName: 'Send button color (focus)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendBoxButtonMessageSendColorOnHover',
        displayName: 'Send button color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ButtonColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'v2_emoji_icon',
        displayName: 'Emoji icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_microphone_icon',
        displayName: 'Microphone icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_removeAttachment_icon',
        displayName: 'Remove attachment icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_send_icon',
        displayName: 'Send icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_stop_icon',
        displayName: 'Stop icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'v2_upload_icon',
        displayName: 'Upload icon',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "UI",
        multiline: true,
    },
    {
        id: 'showVoiceInputSelector',
        displayName: 'Show dictation / keyboard selector',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Dictation,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI.headerOptions",
    },
    {
        id: 'microphoneButtonColorOnDictate',
        displayName: 'Microphone color while listening',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Dictation,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'Speech_SegmentationSilenceTimeoutMs',
        displayName: 'Dictation silence timeout (ms)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Dictation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'sendBoxVoiceWaveformColor',
        displayName: 'Dictation waveform color or gradient',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.Dictation,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "styleOptions",
    },
    {
        id: 'replyToMessageEnabled',
        displayName: 'Allow replying to a message',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonColor',
        displayName: 'Reply button color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonColorOnFocus',
        displayName: 'Reply button color (focus)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonColorOnHover',
        displayName: 'Reply button color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonIconColor',
        displayName: 'Reply button icon color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonIconColorOnFocus',
        displayName: 'Reply button icon color (focus)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyButtonIconColorOnHover',
        displayName: 'Reply button icon color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyCancelButtonColor',
        displayName: 'Reply cancel button color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyCancelButtonColorOnHover',
        displayName: 'Reply cancel button color (hover)',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeBackgroundColor',
        displayName: 'Reply preview background color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeBorderColor',
        displayName: 'Reply preview border color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeBorderRadius',
        displayName: 'Reply preview border radius',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeBorderWidth',
        displayName: 'Reply preview border width',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeMarginBottom',
        displayName: 'Reply preview margin bottom',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModeMarginTop',
        displayName: 'Reply preview margin top',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'druidSendBoxReplyToModePadding',
        displayName: 'Reply preview padding',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.ReplyToMessage,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneBlur',
        displayName: 'Drop-zone background blur',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneSecondaryColor',
        displayName: 'Drop-zone background color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneBackgroundOpacity',
        displayName: 'Drop-zone background opacity',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "UI",
    },
    {
        id: 'dropzonePrimaryColor',
        displayName: 'Drop-zone border and icon color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneBorderWidth',
        displayName: 'Drop-zone border width',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneIconSize',
        displayName: 'Drop-zone icon size',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneTextColor',
        displayName: 'Drop-zone text color',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "UI",
    },
    {
        id: 'dropzoneTextSize',
        displayName: 'Drop-zone text size',
        category: ChatCategory.Composer,
        subCategory: ChatSubCategory.FileDropZone,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "UI",
    },

    // System messages
    {
        id: 'slowConnectionAfter',
        displayName: 'Slow-connection warning delay',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.Connectivity,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendTimeout',
        displayName: 'Message send timeout',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.DeliveryTimeouts,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'sendTimeoutForAttachments',
        displayName: 'Attachment send timeout',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.DeliveryTimeouts,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'hideToaster',
        displayName: 'Hide system alerts',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertLayout,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toasterHeight',
        displayName: 'Height',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toasterMaxHeight',
        displayName: 'Maximum height',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertLayout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastFontSize',
        displayName: 'Font size',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertStyling,
        uiSelectorType: UISelectorType.percentageSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastIconWidth',
        displayName: 'Icon width',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertStyling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastSeparatorColor',
        displayName: 'Separator color',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertStyling,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastTextPadding',
        displayName: 'Text padding',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.AlertStyling,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastErrorColor',
        displayName: 'Error text',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastErrorBackgroundColor',
        displayName: 'Error background',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastWarnColor',
        displayName: 'Warning text',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastWarnBackgroundColor',
        displayName: 'Warning background',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastSuccessColor',
        displayName: 'Success text',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastSuccessBackgroundColor',
        displayName: 'Success background',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastInfoColor',
        displayName: 'Info text',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },
    {
        id: 'toastInfoBackgroundColor',
        displayName: 'Info background',
        category: ChatCategory.SystemMessages,
        subCategory: ChatSubCategory.StatusColors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "styleOptions",
    },

    // Behavior
    {
        id: 'notificationsEnabled',
        displayName: 'Sound on new message',
        category: ChatCategory.Behavior,
        subCategory: ChatSubCategory.Integration,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },
    {
        id: 'applyWebchatCustomizationsOnMultichat',
        displayName: 'Apply chat styles to multichat',
        category: ChatCategory.Behavior,
        subCategory: ChatSubCategory.Integration,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "root",
    },

    // Localization
    {
        id: 'localization',
        displayName: 'Localization',
        category: ChatCategory.Localization,
        subCategory: ChatSubCategory.InterfaceText,
        uiSelectorType: UISelectorType.localizationSelector,
        containerName: "root",
    },

    // Developer
    {
        id: 'customDruidStyleSet',
        displayName: 'Custom style set (JSON)',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.CustomStyling,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "root",
        multiline: true,
        defaultValue: `{
  "webchatRoot": {
    "#druidWebchatRoot_v2 &": {
      ".druid__minimizable__web-chat__default-container-element": {
          "background-color": "#70b244",
          "border-color": "#70b244"
      }
    }
  }
}`,
    },
    {
        id: 'webChatEventHandler',
        displayName: 'Event handler script',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "root",
        multiline: true,
        defaultValue: `(action, currentDruidState) => {
      if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' && DruidWebchat_v2.isNewActivity(currentDruidState, action.payload.activity)) {
        if(action.payload.activity.type === "event" && action.payload.activity.name == "disableEvent") {
          DruidWebchat_v2.disableChat();
        }
      }
    }`,
    },
    {
        id: 'attachmentMiddleware',
        displayName: 'Attachment middleware',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "middlewares",
        multiline: true,
        defaultValue: '({ dispatch }) => next => (args) => next(args)',
    },
    {
        id: 'cardActionMiddleware',
        displayName: 'Card action middleware',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "middlewares",
        multiline: true,
        defaultValue: `({ dispatch }) => next => (args) => {
      const { cardAction} = args;
      console.log(\`clicked \${cardAction.value}\`);
      return next(args);
    }`,
    },
    {
        id: 'activityMiddleware',
        displayName: 'Message activity middleware',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "middlewares",
        multiline: true,
        defaultValue: ` () => next => (...setupArgs) => {
      const [card] = setupArgs;
      const activity = card.activity;
      if ( activity.type == 'message' && activity.text) {
        return (...renderArgs) => (
          (<>
            {
              next(card)(...renderArgs)
            }
          </>)
        );
      }
      return next(...setupArgs);
    }`,
    },
    {
        id: 'activityStatusMiddleware',
        displayName: 'Message status middleware',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "middlewares",
        multiline: true,
        defaultValue: '({ dispatch }) => next => (args) => next(args)',
    },
    {
        id: 'scrollToEndButtonMiddleware',
        displayName: 'Scroll-to-end button middleware',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.EventHandlers,
        uiSelectorType: UISelectorType.reactSelector,
        containerName: "root",
        multiline: true,
        defaultValue: `() => (next) => (args)=> (props) => {
      const nextRender = next(args);
      return nextRender ? <>{next(args)(props)}</> : <></>;
    }`,
    },
    {
        id: 'activityWrapperClassEnabled',
        displayName: 'Add CSS classes to agent messages',
        category: ChatCategory.Developer,
        subCategory: ChatSubCategory.MarkupHooks,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "UI",
    },
];
